import React from 'react'
import TagBrandNewPage from './TagBrandNewPage'

const TagBrandNewContainer = () => {
    return (
        <div className='TagBrandNewContainer'>
            <TagBrandNewPage />
        </div>
    )
}

export default TagBrandNewContainer